import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "50",
      width: "50",
      viewBox: "0 0 50 50"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M50-.006L0 21.01c4.255 4.238 8.512 8.475 12.77 12.712l10.022-6.536-6.567 9.997 12.763 12.763L50-.004zm-5.828 5.83l-16.257 38.64-7.697-7.7 13.36-20.33-20.4 13.28-7.69-7.635z"
    }))
  );
});